import {
  differenceInCalendarMonths,
  format,
  isAfter,
  isValid,
  parse,
  startOfMonth,
  subMonths,
} from "date-fns";
import type { MonthRange, MonthString } from "../types/smsBilling.types";

export const MONTH_FORMAT = "yyyy-MM";

/** 서버(SmsService)와 같은 상한 */
export const BILLING_MAX_MONTHS = 12;

export const toMonthString = (date: Date): MonthString => format(date, MONTH_FORMAT);

export const parseMonth = (value: MonthString): Date =>
  parse(value, MONTH_FORMAT, new Date());

/** 기본 조회 범위: 지난달 ~ 이번 달 */
export const getDefaultRange = (today: Date = new Date()): MonthRange => {
  const thisMonth = startOfMonth(today);
  return {
    fromMonth: toMonthString(subMonths(thisMonth, 1)),
    toMonth: toMonthString(thisMonth),
  };
};

/** 조회를 막아야 하면 안내 문구, 정상이면 null. 서버도 같은 규칙으로 막는다. */
export const validateRange = (
  range: MonthRange,
  today: Date = new Date(),
): string | null => {
  const from = parseMonth(range.fromMonth);
  const to = parseMonth(range.toMonth);
  if (!isValid(from) || !isValid(to)) return "조회월을 선택해 주세요.";
  if (isAfter(from, to)) return "시작월이 종료월보다 늦습니다.";
  if (isAfter(startOfMonth(to), startOfMonth(today)))
    return "종료월은 이번 달까지만 선택할 수 있습니다.";
  if (differenceInCalendarMonths(to, from) >= BILLING_MAX_MONTHS)
    return `조회 기간은 최대 ${BILLING_MAX_MONTHS}개월입니다.`;
  return null;
};

/** "2026-10" → "2026년 10월" */
export const formatMonthLabel = (value: MonthString): string => {
  const date = parseMonth(value);
  return isValid(date) ? format(date, "yyyy년 M월") : value;
};
